import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { LandingService } from '../services';
import { hasLandingProperty } from '../utils';

@Injectable()
export class LandingHasEmail extends hasLandingProperty('email', ['/landing/email']) {
  constructor(landing: LandingService, router: Router) {
    super(landing, router);
  }
}
